const messages = require('./en-US/index.json');

export default messages;
